<template>
  <el-image v-bind="$attrs" v-on="$listeners" class="b-image">
    <div slot="error">
      <slot name="error"></slot>
    </div>
  </el-image>
</template>
<script>
export default {
  name: 'adb-image',
};
</script>
